function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHotelCityFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 28v2H2v-2h28zM24 8h-4.029V7h4.03v1zm-1.029 15h-5v3h-2V9a1 1 0 011-1h1V6a1 1 0 011-1h6.03a1 1 0 011 1v2h1a1 1 0 011 1v17h-2V10h-8.03v3h5v2h-5v2h5v2h-5v2h5v2zM9 25H6v1H4V14a1 1 0 011-1h8a1 1 0 011 1v12h-2V15H6v2h3v2H6v1h3v2H6v1h3v2zM4.985 5.313c.116 0 .231.02.343.063a1 1 0 001.243-.48 1.635 1.635 0 011.46-.895c.725 0 1.374.487 1.575 1.184a1 1 0 00.961.722h.017a.688.688 0 110 1.377H4.985a.986.986 0 010-1.971zm0 3.97h5.6a2.691 2.691 0 002.687-2.688c0-1.242-.847-2.29-1.994-2.597A3.66 3.66 0 008.031 2a3.623 3.623 0 00-2.806 1.323A2.988 2.988 0 002 6.298a2.989 2.989 0 002.985 2.986z",
    fill: props.color
  }));
}

export default SvgIconHotelCityFilled;